










































import { Ref, Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { ProjectEmailTemplate } from '@/api/model/project-email-template'
import { ProviderInstance } from 'vee-validate/dist/types/types'

@Component
export default class InputSelectProjectEmailTemplate extends Vue {
    @Ref() validator!: ProviderInstance
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly projectEmailTemplates!: ProjectEmailTemplate[]
    @Prop() readonly value!: ProjectEmailTemplate
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    internalValue: ProjectEmailTemplate = null
    showOptions: boolean = false
    search: string = ''

    created() {
        this.internalValue = this.value
        window.addEventListener('click', this.onOutsideClick)
    }

    beforeDestroy() {
        window.removeEventListener('click', this.onOutsideClick)
    }

    @Watch('internalValue')
    async onInput(): Promise<void> {
        await this.validator.validate(this.internalValue)
        this.$emit('input', this.internalValue)
    }

    applyClass(option: ProjectEmailTemplate) {
        if (this.value && this.value.type === option.type) {
            return ['input-select__option--selected']
        }

        return []
    }

    toggleOptions(): void {
        if (!this.disabled) {
            this.showOptions = !this.showOptions
        }
    }

    selectOption(option: ProjectEmailTemplate): void {
        this.internalValue = option
        this.showOptions = false
    }

    get selectedOption() {
        if (!this.value) {
            return null
        }
        return this.projectEmailTemplates.find(value => value.type === this.value.type)
    }

    get componentClass(): object {
        return {
            'input-select-projectEmailTemplate': true,
            'input-select': true,
            'input-select--disabled': this.disabled,
            'opened': this.showOptions,
        }
    }

    get filteredProjectEmailTemplates(): ProjectEmailTemplate[] {
        if (!this.search || this.search.length === 0) {
            return this.projectEmailTemplates
        }

        return this.projectEmailTemplates
            .filter(projectEmailTemplate => projectEmailTemplate.type.toLowerCase()
                .includes(this.search.toLowerCase()))
    }

    async onOutsideClick(e: Event) {
        const target = e.target as HTMLDivElement

        if (!this.$el.contains(target)) {
            this.showOptions = false
        }
    }
}
